window.addEventListener('load', function () {
    const animate = 1;
    const nav_control = document.querySelector('.nav_control');
    const nav_open_class = 'nav_open';
    const svg_clip_nav = document.querySelector('clipPath#nav_back path');

    if( nav_control ) {
      nav_control.onclick = function() {
        document.body.classList.toggle(nav_open_class);

        if( animate ) {
            svg_clip_nav.animate({
            d: [
                'path("' + svg_clip_nav.dataset.pathFrom + '")',
                'path("' + svg_clip_nav.dataset.pathTo + '")',
                ]
            },
            {
                duration: 250,
                fill: 'both',
                easing: 'cubic-bezier(.33,.24,.31,.98)'
            }
            );
        }

    }
    }

    nav_fixed();
});

function nav_fixed() {
  let scroll_last = 0,
      init = 0;
  document.addEventListener('scroll', (event) => {
    const target_element = document.querySelector('nav'),
          top_buffer_before_fixed = 200,
          top_buffer_before_return = 50,
          class_fixed = 'fixed',
          class_active = 'active',
          class_init = 'init';
    let   scroll_current = document.documentElement.scrollTop;

    if( scroll_current > top_buffer_before_fixed ) {
      target_element.classList.add(class_fixed);
      if( init < 1 ) {
        target_element.classList.add(class_init);
        init = 1;
      } else {
        target_element.classList.remove(class_init);
      }
    } else if( scroll_current < top_buffer_before_return ) {
      target_element.classList.remove(class_fixed);
      init = 0;
    }

    if( scroll_last > scroll_current ) {
      target_element.classList.add(class_active);
    } else {
      target_element.classList.remove(class_active);
    }

    scroll_last = scroll_current
  });
}

